import React, { FunctionComponent, useMemo } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faExternalLinkAlt,
  faFile,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { AttachedResource } from "../../../../../../../../store/onboarding/cases/types";
import { getFileIcon } from "../../../../../../../../utils/NamesUtils";

type OwnProps = {
  attachment: AttachedResource;
  onAttachmentRemove?: Function;
};

type Props = OwnProps;

const AttachedResourceItem: FunctionComponent<Props> = (props) => {
  const { attachment, onAttachmentRemove } = props;
  
  const attachmentUrl = useMemo(() => {
    let attachmentURL = '';
    if(window.location.host.includes('localhost')) {
      attachmentURL = 'http://localhost:8000'
    } else if (window.location.host === 'staging.readycoach.net'){
      attachmentURL = 'https://stage-api.readycoach.net'
    }
    return attachmentURL;
  },[attachment])

  return (
    <div className="fileCell">
      <div className="fileCellName">
        <a
          className="interventionStepFile"
          href={attachment.attachment_url ? attachmentUrl + attachment.attachment_url : attachment.url}
          title={attachment.title}
          target={"_blank"}
          rel="noopener noreferrer"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          <FontAwesomeIcon
            icon={attachment.url ? faExternalLinkAlt : getFileIcon(attachment.title, attachment.mime_type)}
            size="1x"
            className="pointer"
          />
          &nbsp; {attachment.title}
        </a>
      </div>
      {onAttachmentRemove && (
        <div
          className="fileCellRemove"
          onClick={() => onAttachmentRemove(attachment.id!)}
        >
          <FontAwesomeIcon
            icon={faTimes}
            size="1x"
            style={{ color: "#ffffff" }}
            className="pointer"
          />
        </div>
      )}
    </div>
  );
};

export default AttachedResourceItem;
